/* eslint-disable consistent-return, no-param-reassign, no-new, consistent-this */
import moment from "moment";
const events = require("common/event-aggregator");
const log = require("common/log");
const weekdayCollection = require("./weekday-selection-collection");

const getDataDefault = (modelData) => modelData;

export function renderNewDays ({ getData = getDataDefault, direction }) {
  return (modelData) => {
    const { days, referenceSlots, ...modelRest } = getData(modelData);
    if (direction === "next") {
      weekdayCollection.appendDayData({
        days,
        referenceSlots
      });
      this.model.set({
        ...modelRest
      });
    }
    if (direction === "previous") {
      weekdayCollection.prependDayData({
        days,
        referenceSlots
      });
      this.model.set({
        ...modelRest,
        // Ensure that when navigating backwards we don't cause the date
        // requests to overlap
        lastIncludedDate: this.model.get("lastIncludedDate")
      });
    }
    this.weekdaySelectionView.setData({
      moreDaysInTheFuture: this.model.get("moreDaysInTheFuture"),
      moreDaysInThePast: this.model.get("moreDaysInThePast"),
      firstIncludedDate: this.model.get("firstIncludedDate"),
      lastIncludedDate: this.model.get("lastIncludedDate"),
      direction
    });
    this.weekdaySelectionView.render();
  };
}

export const onPaginateLoadSuccess = ({ direction }) => () => {
  events.trigger(events.CHECKOUT_AVAILABILITY_PAGINATE_LOAD, {
    status: "fulfilled",
    direction
  });
};

export const onPaginateLoadError = ({ direction }) => (error) => {
  log.client(log.ERROR, error);
  events.trigger(events.CHECKOUT_AVAILABILITY_PAGINATE_LOAD, {
    status: "rejected",
    direction
  });
};

export const onPaginateLoadPending = ({ direction }) => {
  events.trigger(events.CHECKOUT_AVAILABILITY_PAGINATE_LOAD, {
    status: "pending",
    direction
  });
};

export const getNextStartDate = (lastIncludedDate) =>
  moment(lastIncludedDate).add(1, "days").format("YYYY-MM-DD");

export const getPreviousStartDate = (firstIncludedDate) =>
  moment(firstIncludedDate).subtract(14, "days");

export const getPreviousEndDate = (firstIncludedDate) =>
  moment(firstIncludedDate).subtract(1, "days").format("YYYY-MM-DD");

export function fetchPaginatedModel ({
  firstIncludedDate,
  lastIncludedDate,
  direction,
  paginateSelectedDate
}) {
  onPaginateLoadPending({ direction });

  new Promise((resolve, reject) => {
    this.basketModel.fetch().then(resolve).fail(reject);
  }).then(({ services, employeeId }) => {
    if (direction === "next") {
      return this.fetchModel({
        services,
        employeeId,
        startDate: getNextStartDate(lastIncludedDate)
      })
        .then(renderNewDays.call(this, { direction, paginateSelectedDate }))
        .then(onPaginateLoadSuccess({ direction }))
        .catch(onPaginateLoadError({ direction }));
    }
    if (direction === "previous") {
      const startDate = getPreviousStartDate(firstIncludedDate);
      const now = moment();

      // Ensure we don't request a date before today
      let formattedDate;
      if (startDate.isSameOrBefore(now)) {
        formattedDate = now.format("YYYY-MM-DD");
      } else {
        formattedDate = startDate.format("YYYY-MM-DD");
      }

      return this.fetchModel({
        services,
        employeeId,
        startDate: formattedDate,
        endDate: getPreviousEndDate(firstIncludedDate)
      })
          .then(renderNewDays.call(this, { direction }))
          .then(onPaginateLoadSuccess({ direction }))
          .catch(onPaginateLoadError({ direction }));
    }
  });
}
